import React, { Fragment } from "react";
import NbfcInventoryList from "../../containers/autionDataList/nbfcInventoryList";
import Header from "../../components/header";
import BackButton from "../../components/backButton";
import { useNavigate } from "react-router-dom";
import Main from "../../components/main";

const InventoryListPage = () => {
    const navigate = useNavigate();
    const backFn = () => {
        navigate('/auctionUploadedList')
    }

	return (
		<Fragment>
			<Header>
				<Header.MaxWidth>
					<Header.Logo
						src="../../assets/title/Tractor world Logo.svg"
						alt="Logo"
					/>
				</Header.MaxWidth>
			</Header>
            <Main>
            <BackButton>
					<BackButton.IconTextConatiner
						onClick={() => backFn()}
						style={{ width: "120px", cursor: "pointer" }}
					>
						<BackButton.Icon
							src="../../assets/arrow/arrow_left.svg"
							alt="arrow_left"
						/>
						<BackButton.Text>Back to Listing</BackButton.Text>
					</BackButton.IconTextConatiner>
				</BackButton>
			<NbfcInventoryList />
            </Main>
		</Fragment>
	);
};

export default InventoryListPage;
